import {
  USER_FETCH,
  IS_LOADED,
  UPDATE_PASSWORD_SUCESS
} from './types';
import { STATUS } from '../../config/constants/states';

const initialState = {
  user: {
    first_name: '',
    last_name: ''
  },
  isLoaded: false,
  passwordIsUpdated: STATUS.PENDING,
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case USER_FETCH:
      return { ...state, user: payload };
    case IS_LOADED:
      return { ...state, isLoaded: payload };
    case UPDATE_PASSWORD_SUCESS:
      return { ...state, passwordIsUpdated: payload };
    default:
      return state;
  }
}